export default "__VITE_ASSET__plHHOMOt__"